document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var ASC = document;

  /* Scroll reveal */
  var revs = ASC.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revs.forEach(function (r) { io.observe(r); });
  } else { revs.forEach(function (r) { r.classList.add('in'); }); }

  /* Nav shadow */
  var nav = ASC.querySelector('#asc-nav');
  if (nav) window.addEventListener('scroll', function () {
    nav.classList.toggle('scrolled', window.scrollY > 12);
  }, { passive: true });

  /* Count-up */
  function count(el) {
    var t = parseFloat(el.getAttribute('data-count')), sfx = el.getAttribute('data-suffix') || '', dur = 1300, s = null;
    function step(ts) { if (!s) s = ts; var p = Math.min((ts - s) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(e * t).toLocaleString() + sfx;
      if (p < 1) requestAnimationFrame(step); else el.textContent = t.toLocaleString() + sfx; }
    requestAnimationFrame(step);
  }
  var cs = ASC.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } }); }, { threshold: 0.6 });
    cs.forEach(function (c) { cio.observe(c); });
  } else { cs.forEach(count); }

  /* Animate conversion bars (reason 4) when they scroll into view */
  var bars = ASC.querySelectorAll('.cv-side .bar i[data-w]');
  if (bars.length && 'IntersectionObserver' in window) {
    var bio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.style.width = e.target.getAttribute('data-w') + '%'; bio.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    bars.forEach(function (x) { bio.observe(x); });
  } else {
    bars.forEach(function (x) { x.style.width = x.getAttribute('data-w') + '%'; });
  }

  /* Generic carousel helper (scoped to ASC) */
  function carousel(slidesSel, opts) {
    var slides = Array.prototype.slice.call(ASC.querySelectorAll(slidesSel));
    if (!slides.length) return;
    var i = 0,
        dots = opts.dots ? Array.prototype.slice.call(ASC.querySelectorAll(opts.dots)) : [],
        thumbs = opts.thumbs ? Array.prototype.slice.call(ASC.querySelectorAll(opts.thumbs)) : [];
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    var pv = opts.prev && ASC.querySelector(opts.prev); if (pv) pv.addEventListener('click', function () { go(i - 1); });
    var nx = opts.next && ASC.querySelector(opts.next); if (nx) nx.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (opts.auto) setInterval(function () { go(i + 1); }, opts.auto);
    return go;
  }

  /* Hero carousel (product / replaces / survey / advisory slides) */
  carousel('.hero-slide', { prev: '.adv-arrow.prev', next: '.adv-arrow.next', dots: '.adv-dots i', auto: 4200 });

  /* Slow continuous auto-scroll for horizontal rails (videos, info bar) */
  ASC.querySelectorAll('.auto-scroll').forEach(function (el) {
    var dup = false, paused = false, resume, pos = 0;
    function ensureDup() {
      if (!dup && el.scrollWidth > el.clientWidth + 4) {   // only clone if it actually overflows
        Array.prototype.slice.call(el.children).forEach(function (k) { el.appendChild(k.cloneNode(true)); });
        dup = true;
      }
    }
    function pause() { paused = true; clearTimeout(resume); }
    function play() { clearTimeout(resume); resume = setTimeout(function () { pos = el.scrollLeft; paused = false; }, 1500); }
    el.addEventListener('mouseenter', pause); el.addEventListener('mouseleave', play);
    el.addEventListener('touchstart', pause, { passive: true }); el.addEventListener('touchend', play, { passive: true });
    window.addEventListener('resize', ensureDup);
    ensureDup();
    setTimeout(ensureDup, 400);
    setInterval(function () {
      if (paused || !dup) return;
      var half = el.scrollWidth / 2;
      if (half < 10) return;
      pos += 0.5;
      if (pos >= half) pos -= half;   // seamless loop (2nd half is identical)
      el.scrollLeft = pos;
    }, 16);
  });

  /* Sticky bar: shows after the hero, tucks away over the offer + footer */
  var bar = ASC.querySelector('#asc-stickybar');
  var hero = ASC.querySelector('.hero');
  var buy = ASC.querySelector('#buy');
  var foot = ASC.querySelector('.site-footer');
  if (bar && 'IntersectionObserver' in window) {
    var vis = {};
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { vis[e.target.getAttribute('data-sb')] = e.isIntersecting; });
      var hide = vis.hero || vis.buy || vis.foot;
      bar.style.transform = hide ? 'translateY(100%)' : 'translateY(0)';
    }, { threshold: 0.04 });
    if (hero) { hero.setAttribute('data-sb', 'hero'); sio.observe(hero); }
    if (buy) { buy.setAttribute('data-sb', 'buy'); sio.observe(buy); }
    if (foot) { foot.setAttribute('data-sb', 'foot'); sio.observe(foot); }
  }

  /* Reason videos use native `autoplay` (like the 7rgm lander) - no JS, no scroll jank. */

  /* Countdown - duration based, persists per visitor via localStorage, loops on expiry */
  var cd = ASC.querySelector('.asc-countdown');
  if (cd) {
    var hh = cd.querySelector('[data-cd="hh"]'), mm = cd.querySelector('[data-cd="mm"]'), ss = cd.querySelector('[data-cd="ss"]');
    var mins = parseInt(cd.getAttribute('data-minutes'), 10); if (!mins || mins < 1) mins = 720;
    var key = 'asc-cd';
    var end;
    try { end = parseInt(localStorage.getItem(key), 10); } catch (e) { end = NaN; }
    var now = Date.now();
    if (!end || isNaN(end) || end < now) { end = now + mins * 60000; try { localStorage.setItem(key, end); } catch (e) {} }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var t = Math.floor(Math.max(0, end - Date.now()) / 1000);
      if (hh) hh.textContent = pad(Math.floor(t / 3600));
      if (mm) mm.textContent = pad(Math.floor((t % 3600) / 60));
      if (ss) ss.textContent = pad(t % 60);
      if (t <= 0) { end = Date.now() + mins * 60000; try { localStorage.setItem(key, end); } catch (e) {} }
    }
    tick();
    setInterval(tick, 1000);
  }
});

/* Video testimonials: first frame shown, click to play with sound, pauses others */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tcard.vid').forEach(function (card) {
    var v = card.querySelector('.tc-video'); var pp = card.querySelector('.tc-pp');
    if (!v) return;
    v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0.5; } catch (e) {} });
    function toggle() {
      if (v.paused) {
        document.querySelectorAll('.tcard.vid .tc-video').forEach(function (o) { if (o !== v) o.pause(); });
        v.muted = false; v.play().catch(function () {});
      } else { v.pause(); }
    }
    v.addEventListener('click', toggle);
    if (pp) pp.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    v.addEventListener('play', function () { card.classList.add('playing'); });
    v.addEventListener('pause', function () { card.classList.remove('playing'); });
    v.addEventListener('ended', function () { card.classList.remove('playing'); });
  });
});
